<template>
    <div @click="goToPage" v-if="summary" class="summary_box relative h-0 cursor-pointer overflow-hidden" :class="[summary ? summary.slug : '']">
        <img v-if="summary.image" class="absolute top-0 left-0 block w-full h-full object-cover" :src="'fr/images/summary/' + summary.image" alt="" />
        <div class="summary_box_overlay absolute top-0 left-0 w-full h-full lg:opacity-0 flex justify-start items-center">
            <p class="font-FrutigerLT_Light_Cond relative text-xl md:text-xs lg:text-2xl text-white ml-4 md:ml-2 lg:ml-4" v-html="summary.title"></p>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'SummaryBox',
        props: {
            summary: null
        },
        methods: {
            goToPage() {
                this.$router.push({ name: 'catalogue', params: { slug: this.summary.slug } });
            }
        }
    };
</script>

<style scoped lang="scss">
    .summary_box {
        font-family: Frutiger Lt;
        width: calc($box_size_mobile - $box_spacing);
        padding-bottom: calc($box_size_mobile - $box_spacing);
        margin-top: $box_spacing;
        @media (min-width: 768px) {
            width: calc($box_size - $custom_varible);
            padding-bottom: calc($box_size - $custom_varible);
            margin-left: $box_spacing;
        }
        .summary_box_overlay {
            font-family: Frutiger Lt;
            background-color: rgba(15, 98, 207, 0.51);
            transition: opacity 250ms ease-in-out;
            @media (min-width:1024px) {
                &:hover {
                    opacity: 1;
                }
           }
        }
        
    }

</style>
